var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 7.8335V5.16683C4.66667 4.28277 5.01786 3.43493 5.64298 2.80981C6.2681 2.18469 7.11595 1.8335 8 1.8335C8.88406 1.8335 9.7319 2.18469 10.357 2.80981C10.9821 3.43493 11.3333 4.28277 11.3333 5.16683V7.8335M3.33333 7.8335H12.6667C13.403 7.8335 14 8.43045 14 9.16683V13.8335C14 14.5699 13.403 15.1668 12.6667 15.1668H3.33333C2.59695 15.1668 2 14.5699 2 13.8335V9.16683C2 8.43045 2.59695 7.8335 3.33333 7.8335Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.10282fc1dd727136c7477cbbdd067014.svg";
export { ForwardRef as ReactComponent };